import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Item } from 'src/app/models/item';
import { Chart, ChartConfiguration, ChartData, ChartDataset, ChartType, TooltipItem } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import DatalabelsPlugin from 'chartjs-plugin-datalabels';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import { GeneralService } from 'src/app/services/general.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import * as moment from 'moment';
@Component({
  selector: 'app-dashboard-sales-panel',
  templateUrl: './dashboard-sales-panel.component.html',
  styleUrls: ['./dashboard-sales-panel.component.css']
})
export class DashboardSalesPanelComponent {
  @Output() policyTypeCheckChange = new EventEmitter();
  @Input() userType:number = 4;
  selectedStartDate:any = moment(new Date()).add(-7, 'days').format();
  selectedEndDate:any = new Date();  
  policyTypeList:{text:string,value:number}[] = [{text:"Both",value:2},{text:"Offline",value:1},{text:"Online",value:0}];
  policyType:number = 0;
  agentList:any[] = [];
  resellerList:any[] = [];
  originalResellerList:any[] = [];
  distributorList:any[] = [];
  originalAgentList:any[] = [];
  activeTabs1:number = 99;
  isDateRangeChanged:boolean = false;
  policySoldCount:number = 0;
  policySoldSales:number = 0;
  policySoldCountPrevious:number = 0;
  policySoldSalesPrevious:number = 0;
  policySoldCompanyList:any;
  @Input() selectedAgentIds:string = "";
  distributorId:string = "";
  resellerId:string = "";
  constructor(private generalService:GeneralService, private dashboardSevice :DashboardService){

  }
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  async onPolicyTypeCheck(){
    // this.bindDashboardData();
    //this.bindLineChartDataPolicySold(true);
    this.policyTypeCheckChange.emit(this.policyType);
  }

  onDistributorMultiSelectChange(selectItems: Item[]): void {
    let selectedIds  = selectItems.map((item:Item) => {return item.id}).toString();
    this.resellerList = this.originalResellerList.filter((f:any)=> {return selectedIds?.split(',')?.includes(f.DistributorId?.toString())});
    this.onResellerMultiSelectChange(this.resellerList);
  }
  
  onResellerMultiSelectChange(selectItems: Item[]): void {
    let selectedIds  = selectItems.map((item:Item) => {return item.id}).toString();
    this.agentList = this.originalAgentList.filter((f:any)=> {return selectedIds?.split(',')?.includes(f.ResellerId?.toString())});
    this.onAgentMultiSelectChange(this.agentList);
  }

  onAgentMultiSelectChange(selectItems: Item[]): void {
    this.selectedAgentIds = selectItems.map((item:Item) => {return item.id}).toString();
    this.isDateRangeChanged  = false;
    this.bindLineChartDataPolicySold();
  }

  changeTabsone(tab: number) {
    this.activeTabs1 = tab;
    this.isDateRangeChanged = false;
    this.bindLineChartDataPolicySold();
  }

  bindLineChartDataPolicySoldCall(StartDate:string,EndDate:string,policyType:number,policyTypeCahnge=false,distributorId = "", resellerId = ""){
    this.selectedStartDate = StartDate;
    this.selectedEndDate = EndDate;
    this.policyType = policyType;
    this.distributorId = distributorId;
    this.resellerId = resellerId;
    this.bindLineChartDataPolicySold(policyTypeCahnge);
  }

  bindLineChartDataPolicySold(policyTypeCahnge=false){
      let obj={
        DistributorId:this.distributorId??"",
        ResellerId:this.resellerId??"",
        AgentId:this.selectedAgentIds,
        ProductId:this.activeTabs1,
        SystemCompanyId:1,
        StartDate:this.selectedStartDate,//moment(this.selectedStartDate).format('YYYY-MM-DD'),
        EndDate:this.selectedEndDate,//moment(this.selectedEndDate).format('YYYY-MM-DD'),
        policyType:this.policyType
      }
      this.dashboardSevice.PolicySoldLineChartData(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        for(let i=0;i<response?.result?.length;i++)
        {
          if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
          {
            switch(i)
            {
              case 0 :
              let policySoldList = JSON.parse(response.result[i]);
              let premiumList = policySoldList.map((obj:any) => {return obj.premium});
              let countList = policySoldList.map((obj:any) => {return obj.count});
              
              this.policySoldCount = countList.reduce((a:any, b:any) => a + b, 0);
              this.policySoldSales = premiumList.reduce((a:any, b:any) => a + b, 0);
              this.lineChartDataPolicySold = {
                datasets: [
                  {
                    data: countList,
                    customData: premiumList,
                    label: 'Count ',
                    backgroundColor: '#9515181A',        
                    borderColor: '#10A0C1',
                    pointBackgroundColor: 'rgba(148,159,177,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: '#10A0C1',
                    borderWidth: 1.5,
                    fill: 'origin'
                  }as CustomChartDataset
                ],
                labels: policySoldList.map((obj:any) => {return obj.date}),
              };
  
              break;
              case 1 :
                this.policySoldCompanyList= JSON.parse(response.result[i]);
                this.policySoldCompanyList.sort((a:any,b:any)=> b.premium > a.premium ? 1 : -1);
              break;
              case 2 :
                if(this.isDateRangeChanged  == true || policyTypeCahnge){
                  this.agentList= JSON.parse(response.result[i]);
                  this.originalAgentList = JSON.parse(response.result[i]);
                  this.resellerList = this.generalService.distinct_name(JSON.parse(response.result[i]).map((m:any)=> {return {id: m.ResellerId, name:m.ResellerName, checked:1, DistributorId:m.DistributorId}}));
                  this.originalResellerList = JSON.parse(JSON.stringify(this.resellerList));
                  this.distributorList = this.generalService.distinct_name(JSON.parse(response.result[i]).map((m:any)=> {return {id: m.DistributorId, name:m.DistributorName, checked:1}}));
                }
                this.isDateRangeChanged  = false;
              break;
              case 3 :
                let policySoldListPrev = JSON.parse(response.result[i]);
                let premiumListPrev = policySoldListPrev.map((obj:any) => {return obj.premium});
                let countListPrev = policySoldListPrev.map((obj:any) => {return obj.count});
                
                this.policySoldCountPrevious = countListPrev.reduce((a:any, b:any) => a + b, 0);
                this.policySoldSalesPrevious = premiumListPrev.reduce((a:any, b:any) => a + b, 0);
              break;
              case 4 :
                //this.topPerfAgent= JSON.parse(response.result[i]);            
              break;
              case 5 :
                //this.topRecentAgent= JSON.parse(response.result[i]);              
              break;
              case 6 :
                // this.distributorDDLList= JSON.parse(response.result[i]);
                // if(this.distributorDDLList.length > 0){
                //   this.selectedDistributor = this.distributorDDLList[0].id;
                // }              
              break;
            }          
          }
        }
      }
      });
    }

    public lineChartData: ChartConfiguration['data'] = {
      datasets: [
        {
          data: [20, 42, 40, 60, 41, 82, 62, 85],
          label: 'Series A',
          backgroundColor: '#9515181A',
  
          borderColor: '#10A0C1',
          pointBackgroundColor: 'rgba(148,159,177,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#10A0C1',
          borderWidth: 1.5,
          fill: 'origin',
        }
      ],
      labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    };
  
    public lineChartDataPolicySold: ChartConfiguration['data'] = {
      datasets: [
        {
          data: [],
          label: 'Series A',
          backgroundColor: '#9515181A',        
          borderColor: '#10A0C1',
          pointBackgroundColor: 'rgba(148,159,177,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#10A0C1',
          borderWidth: 1.5,
          fill: 'origin',
        }as CustomChartDataset
      ],
      labels: [],
    };
  
    public lineChartOptionsPolicySold: ChartConfiguration['options'] = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0.38,
        },
      },
      scales: {
        // We use this empty structure as a placeholder for dynamic theming.
        x: {
          grid: {
            display: false, // Hide the x-axis grid lines
          },
          ticks: {
            stepSize: 30, // Set the spacing between grid lines
          },
        },
        y: {
          position: 'left',
          grid: {
            display: false, // Hide the x-axis grid lines
          },
          ticks: {
            stepSize: 2, // Set the spacing between grid lines
          },
          title: {
            display: true,
            text: 'Sales Trend',   // 👈 Y-axis label
            font: {
              size: 16
            }
          }
        },
        y1: {
          display: false,
          position: 'right',
          grid: {
            display: false,
            color: 'rgba(255,0,0,0.3)',
          },
          ticks: {
            color: 'red',
          },
        },
      },
  
      plugins: {
        legend: { display: false },
        title: {
          display: true,
          text: 'Sales Trend',
          font: {
            size: 18,
            weight: 'bold'
          },
          padding: {
            top: 10,
            bottom: 20
          },
          color: '#333',
          align: 'center' // 'start' | 'center' | 'end'
        },
        annotation: {
          annotations: [
            {
              type: 'line',
              scaleID: 'x',
              // value: 'March',
              // borderColor: 'orange',
              // borderWidth: 2,
              label: {
                display: true,
                position: 'center',
                color: 'orange',
                content: 'LineAnno',
                font: {
                  weight: 'bold',
                },
              },
            },
          ],
        },
        tooltip: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem: TooltipItem<'line'>) {
              let dataset = tooltipItem.dataset as CustomChartDataset;
              let value = tooltipItem.raw; // Get the data value
              let extraInfo = new Intl.NumberFormat('en-US').format(parseInt((dataset.customData ? dataset.customData[tooltipItem.dataIndex] : '0')??'0'));
              return [
                `Count  : ${value}`,
                `Sales: ${extraInfo}`
              ];
            }
          }
        }
      },
    };
  
    public lineChartOptions: ChartConfiguration['options'] = {
      elements: {
        line: {
          tension: 0.38,
        },
      },
      scales: {
        // We use this empty structure as a placeholder for dynamic theming.
        x: {
          grid: {
            display: false, // Hide the x-axis grid lines
          },
          ticks: {
            stepSize: 30, // Set the spacing between grid lines
          },
        },
        y: {
          position: 'left',
          grid: {
            display: false, // Hide the x-axis grid lines
          },
          ticks: {
            stepSize: 20, // Set the spacing between grid lines
          },
        },
        y1: {
          display: false,
          position: 'right',
          grid: {
            display: false,
            color: 'rgba(255,0,0,0.3)',
          },
          ticks: {
            color: 'red',
          },
        },
      },
  
      plugins: {
        legend: { display: false },
        annotation: {
          annotations: [
            {
              type: 'line',
              scaleID: 'x',
              // value: 'March',
              // borderColor: 'orange',
              // borderWidth: 2,
              label: {
                display: true,
                position: 'center',
                color: 'orange',
                content: 'LineAnno',
                font: {
                  weight: 'bold',
                },
              },
            },
          ],
        },
      },
    };
  
    public lineChartType: ChartType = 'line';
}

interface CustomChartDataset extends ChartDataset<'line', number[]> {
  customData?: string[];
}